import { Box, Checkbox, FormHelperText, IconButton } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from '@material-ui/icons/Folder';
import Axios from 'axios';
import JSZip from 'jszip';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../../actions";
import ServerFilesController from "../../../../../API/server_files";
import MyTextField from '../../../../utils/MyTextField';
import { getConsultingId } from '../../../../utils/utils';
import { ACCREDITATION_DEFAULT_SECTION_NAMES, ROOT_ACCREDITATION_DEFAULT_SECTION } from '../AccreditationScreen';

const useStyles = makeStyles({
    root: { display: 'flex', flexDirection: 'column' },
    dirName: { color: 'black', cursor: 'pointer', '&:hover': { color: 'blue' } },
    file: { cursor: 'pointer', '&:hover': { color: 'blue', '& svg': { color: 'blue' } } }
});

const MAX_DIRS_BY_DIR = 10;

const FILES = {
    // doc: 'credenciamento_documentacao',
    manual: 'credenciamento_manuais',
    terms: 'credenciamento_modelos',
    //institutions: 'credenciamento_instituicoes'
};

const defaultYearsToTermsFolders = [2024, 2025, 2026];

//Diferencia as recusas do backend (sem permissão, limite de requisições) do erro genérico
function getServerFilesErrorMessage(error, defaultMessage) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) return 'Sem permissão para esta ação';
    if (status === 429) return 'Muitas requisições, aguarde um instante';
    return defaultMessage;
}

function AccreditationBaseTab({ tabType, ...props }) {

    const { setCurrentBreadcrumbOnScreen } = props;

    const currentUser = useSelector(state => state.currentUser);
    const clientOn = useSelector(state => state.clientOn);

    const classes = useStyles();
    const dispatch = useDispatch();
    const [files, setFiles] = useState(null);
    const [breadcrumb, setBreadcrumb] = useState();
    const [showNewFolderRow, setShowNewFolderRow] = useState(false);
    const [newFolderName, setNewFolderName] = useState('');
    const [checked, setChecked] = useState([]);

    const getRootPath = (type, clientId, consultingId) => {
        // doc: 'CREDENCIAMENTO/Documentacao/',

        switch (type) {
            case 'manual':
                return `arquivos/${consultingId}/${ROOT_ACCREDITATION_DEFAULT_SECTION}/${clientId}/${ACCREDITATION_DEFAULT_SECTION_NAMES.manuals}/`;
            case 'terms':
                return `arquivos/${consultingId}/${ROOT_ACCREDITATION_DEFAULT_SECTION}/${clientId}/${ACCREDITATION_DEFAULT_SECTION_NAMES.terms}/`;
            // case 'institutions':
            //     return `arquivos/${consultingId}/CLIENTS_ACCREDITATION_ZONE/${clientId}/Lista_Instituicoes_Credenciadas/`;
            default:
                return null;
        }
    };

    // Usar consultingId 4 (LEMA) que é onde estão os arquivos de Credenciamento
    const CONSULTING_ID = useMemo(() => {
        return getConsultingId(currentUser);
    }, [currentUser]);

    const CREDENCIAMENTO_CLIENT_PATH = useMemo(() => {
        if (!clientOn?.client?.id || !CONSULTING_ID || !tabType) return;
        return getRootPath(tabType, clientOn.client.id, CONSULTING_ID);
    }, [tabType, clientOn?.client?.id, CONSULTING_ID]);

    const doGetFilesByDir = useCallback(async (dir = CREDENCIAMENTO_CLIENT_PATH) => {

        if (!CONSULTING_ID || !CREDENCIAMENTO_CLIENT_PATH) return;
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Carregando...' }));
        try {

            console.log("DIR: ", dir);
            // Passar consultingId obrigatoriamente conforme exigido pelo backend
            const response = await ServerFilesController.getFilesByDir({ dir, consultingId: CONSULTING_ID, isClientAccreditationZone: true });
            if (response.success) {
                setBreadcrumb(response.body.breadcrumb.slice(2));
                const newFiles = response.body.files;
                setFiles(newFiles);
                if (newFiles?.length === 0 && (tabType === 'terms' || tabType === 'manual')) {
                    dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Pasta vazia' }));
                } else {
                    dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
                }
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, emptyMessage: 'Erro ao carregar' }));
                setFiles([]);
            }
        } catch (error) {
            console.error('Erro ao carregar arquivos:', error);
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
            setFiles([]);
        }
    }, [dispatch, CREDENCIAMENTO_CLIENT_PATH, CONSULTING_ID]);

    const currentBreadcrumb = useMemo(() => breadcrumb?.[breadcrumb?.length - 1], [breadcrumb]);

    const doDelete = useCallback(async () => {
        if (checked.length > 0) {
            try {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Deletando...' }));
                await ServerFilesController.deleteByPaths(checked);
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'success', message: 'Deletado com sucesso' }));
                setChecked([]);
                await doGetFilesByDir(currentBreadcrumb.path);
            } catch (error) {
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: getServerFilesErrorMessage(error, "Erro ao deletar") }));
            }
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }, [checked, currentBreadcrumb, dispatch, doGetFilesByDir]);

    const doDownload = useCallback(async () => {
        if (checked.length === 1 && !checked[0].endsWith('/')) {
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Baixando...' }));
            try {
                const { data } = await ServerFilesController.downloadFile({ dir: checked[0] });
                Object.assign(document.createElement('a'), { target: '_blank', href: data.presignedUrl }).click();
            } catch (error) {
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: "Erro ao baixar" }));
            }
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
            return;
        }

        if (checked.length >= 1) {
            try {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Baixando...' }));
                const filesResponse = await ServerFilesController.downloadRecursive(checked);
                const presignedUrls = Object.entries(filesResponse.data.presignedUrls);
                const zip = new JSZip();
                for (const [path, presignedUrl] of presignedUrls) {
                    const response = await Axios.get(presignedUrl, { responseType: 'blob' });
                    const fileName = path.replace(currentBreadcrumb.path, '');
                    zip.file(fileName, response.data, { createFolders: true });
                }
                const content = await zip.generateAsync({ type: "blob" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(content);
                link.download = FILES[tabType] + ".zip";
                link.click();
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'success', message: 'Baixado com sucesso' }));
                setChecked([]);
                await doGetFilesByDir(currentBreadcrumb.path);
            } catch (error) {
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: "Erro ao baixar" }));
            }
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }, [checked, currentBreadcrumb, dispatch, doGetFilesByDir, tabType]);

    const doCreateFolder = useCallback(async (folderName) => {

        //Regra de criação de diretórios, cliente pode ter até 10 pastas por diretório
        if (files?.filter(f => f.isDir).length >= MAX_DIRS_BY_DIR) {
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'warning', message: `Número máximo de pastas por diretório atingido (${MAX_DIRS_BY_DIR})` }));
            return;
        }
        if (folderName == ACCREDITATION_DEFAULT_SECTION_NAMES.terms) {
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'warning', message: 'Nome de pasata reservado, crie com outro nome' }));
            return;
        }
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Criando...' }));
        const folderNameTrimmed = folderName.trim();
        const folderPath = currentBreadcrumb.path + folderNameTrimmed;
        try {
            await ServerFilesController.createNewFolder(folderPath);
            await resetCreateNewFolder();
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'success', message: 'Pasta criada' }));
        } catch (error) {
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: getServerFilesErrorMessage(error, "Erro ao criar pasta") }));
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }, [currentBreadcrumb, dispatch]);

    const doUpload = useCallback(async (filesArray) => {
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Enviando...' }));
        try {

            const responseUpload = await ServerFilesController.uploadMultipleFiles(filesArray, currentBreadcrumb.path, true);
            if (responseUpload.find(r => r === "MAX_FILE_SIZE_EXCEEDED")) {
                dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
                dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: "Um ou mais arquivos excedem o tamanho máximo permitido de 20MB." }));
                return;
            }
            await doGetFilesByDir(currentBreadcrumb.path);
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'success', message: "Upload realizado!" }));
        } catch (error) {
            dispatch(allActions.mainAlertActions.setMainAlert({ show: true, type: 'error', message: "Erro ao enviar" }));
            dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        }
    }, [currentBreadcrumb, doGetFilesByDir, dispatch]);

    async function resetCreateNewFolder() {
        setShowNewFolderRow(false);
        setNewFolderName('');
        return doGetFilesByDir(currentBreadcrumb.path);
    }

    const handleCheckboxSelection = (value) => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
        if (currentIndex === -1) newChecked.push(value);
        else newChecked.splice(currentIndex, 1);
        setChecked(newChecked);
    };

    const checkAndCreateDefaultTermsFolder = useCallback(async () => {

        if (!currentBreadcrumb || !CONSULTING_ID || !files) return;

        const foldersNames = files.map(el => el.fileName);
        //console.log("checkAndCreateDefaultTermsFolder files: ", files);
        if (defaultYearsToTermsFolders.every(year => foldersNames.includes(year.toString()))) return;
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: true, loadMessage: 'Criando pastas iniciais...' }));
        for (let index = 0; index < defaultYearsToTermsFolders.length; index++) {
            const year = defaultYearsToTermsFolders[index];
            if (files?.findIndex(f => f.isDir && f.fileName === year.toString()) === -1) {
                const folderPath = `${currentBreadcrumb.path}${year}/`;
                await ServerFilesController.createNewFolder(folderPath);
            }
        }

        await doGetFilesByDir(currentBreadcrumb.path)

    }, [currentBreadcrumb, CONSULTING_ID, files]);

    useEffect(() => {
        // console.log("TAB TYPE: ", tabType);
        // console.log("currentBreadcrumb: ", currentBreadcrumb);

        const isRootTermsSection = currentBreadcrumb?.label === ACCREDITATION_DEFAULT_SECTION_NAMES.terms;
        // console.log("isRootTermsSection: ", isRootTermsSection);
        if (tabType == "terms" && isRootTermsSection && currentBreadcrumb && files && files.length !== 3) {

            checkAndCreateDefaultTermsFolder();

        }
    }, [tabType, currentBreadcrumb, files]);

    useEffect(() => {
        if (!currentBreadcrumb) return;
        if (setCurrentBreadcrumbOnScreen) {
            setCurrentBreadcrumbOnScreen(currentBreadcrumb);
        }
    }, [currentBreadcrumb]);

    useEffect(() => {
        const handleDelete = () => doDelete();
        const handleDownload = () => doDownload();
        const handleCreateFolder = () => setShowNewFolderRow(true);
        const handleUpload = async (e) => doUpload(Array.from(e.detail.files));

        window.addEventListener('credenciamentoDelete', handleDelete);
        window.addEventListener('credenciamentoDownload', handleDownload);
        window.addEventListener('credenciamentoCreateFolder', handleCreateFolder);
        window.addEventListener('credenciamentoUpload', handleUpload);

        return () => {
            window.removeEventListener('credenciamentoDelete', handleDelete);
            window.removeEventListener('credenciamentoDownload', handleDownload);
            window.removeEventListener('credenciamentoCreateFolder', handleCreateFolder);
            window.removeEventListener('credenciamentoUpload', handleUpload);
        };
    }, [doDelete, doDownload, doUpload]);

    useEffect(() => {
        if (!CONSULTING_ID || !CREDENCIAMENTO_CLIENT_PATH) return;
        console.log("CHAMANDO GET FILES AQUI");
        doGetFilesByDir(CREDENCIAMENTO_CLIENT_PATH);
    }, [CREDENCIAMENTO_CLIENT_PATH, doGetFilesByDir]);

    return (
        <div className={classes.root}>
            {
                breadcrumb?.length > 1 && (

                    <div style={{ padding: "16px" }}>

                        {breadcrumb?.map((crumb, index) => {
                            const isLast = index === breadcrumb.length - 1;
                            return (
                                <span key={`breadcrumb-${index}`} className={classes.dirName} onClick={() => doGetFilesByDir(crumb.path)}>
                                    {crumb.label}{!isLast && ' > '}
                                </span>
                            );
                        })}
                    </div>
                )
            }
            <div className={'defaultScrollWithHeaderContent'}>
                <List style={{ width: '100%', padding: '16px' }}>
                    {showNewFolderRow && (
                        <ListItem key={`new-folder`} style={{ width: '100%' }}>
                            <ListItemIcon>
                                <FolderIcon style={{ color: '#e1b12c' }} />
                            </ListItemIcon>
                            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                                <ListItemText primary={
                                    <>
                                        <Box style={{ display: 'flex', gap: 4 }}>
                                            <MyTextField required id={`new-folder`} verysmall variant="outlined"
                                                value={newFolderName} onChange={(value) => setNewFolderName(value)} onBlur={resetCreateNewFolder}
                                                onKeyDown={(event) => {
                                                    if (event.keyCode === 13 && newFolderName.trim() !== '') doCreateFolder(newFolderName);
                                                    else if (event.keyCode === 27) resetCreateNewFolder();
                                                }}
                                                placeholder="Nome da pasta..." autoFocus />
                                            <IconButton disableRipple style={{ padding: 0, background: 'none' }} onClick={resetCreateNewFolder}>
                                                <CancelIcon color="error" />
                                            </IconButton>
                                        </Box>
                                        <FormHelperText>Aperte <strong>Enter</strong> para criar.</FormHelperText>
                                    </>
                                } />
                            </div>
                        </ListItem>
                    )}
                    {files && files.map((row, index) => {
                        const labelId = row.path;
                        return (
                            <ListItem key={`file-${index}`} onClick={() => (row.isDir ? doGetFilesByDir : () => { })(row.path)}
                                button={row.isDir} style={{ width: '100%' }} className={!row.isDir ? classes.file : ''}>
                                <ListItemIcon style={{ alignItems: 'center' }}>
                                    <Checkbox checked={checked.indexOf(labelId) !== -1} onClick={(event) => {
                                        event.stopPropagation();
                                        handleCheckboxSelection(labelId);
                                    }} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': labelId }} />
                                    {row.isDir ? <FolderIcon style={{ color: '#e1b12c' }} /> : <DescriptionIcon style={{ color: '#9c88ff' }} />}
                                    <span style={{ marginRight: '20px' }} />
                                </ListItemIcon>
                                <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                                    <ListItemText primary={row.fileName} />
                                    {!row.isDir && <span style={{ fontSize: '10px' }}>Clique para baixar</span>}
                                </div>
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        </div>
    );
}

export default AccreditationBaseTab;